import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import { DeviceVariantRadioOption } from 'modules/it_management/components/DeviceVariantSelector/types'
import { F0Text } from '@factorialco/f0-react'

export interface DeviceVariantRadioProps {
  variant: DeviceVariantRadioOption
  value?: string
  onChange: (value: string) => void
}

const RadioButton = ({
  id,
  label,
  description,
  selected,
  value,
  onChange,
}: {
  id: string
  label: string
  description: string
  selected: boolean
  value: string
  onChange: (value: string) => void
}) => {
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      padding="s12"
      className={`cursor-pointer`}
      border={{
        all: { style: 'solid', width: 's1', color: selected ? 'group7' : 'grey400' },
      }}
      width="full"
      borderRadius={{ all: 'abs012' }}
      style={{
        backgroundColor: selected
          ? 'color-mix(in srgb, var(--color-group7) 10%, transparent)'
          : 'transparent',
      }}
      onClick={() => onChange(value)}
    >
      <Box className="flex-1 min-w-0" flexDirection="column" gap="s4">
        <F0Text variant="label" content={label} />
        {description && <F0Text ellipsis variant="small" content={description} />}
      </Box>

      <Box
        width="s20"
        height="s20"
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
        flexNoShrink
        background={selected ? 'group7' : 'white'}
        borderRadius={{ all: 'abs100' }}
      >
        {selected && <Box background="white" className="h-2 w-2 rounded-full bg-blue-600" />}
      </Box>
    </Box>
  )
}

export const DeviceVariantRadio: React.FC<DeviceVariantRadioProps> = ({
  variant,
  value,
  onChange,
}) => {
  return (
    <Box flexDirection="column">
      <SectionHeader title={variant.title} description={''} />
      <Box flexDirection="column" gap="s8">
        {variant.variants.map((option) => {
          const isSelected = option.id === value

          return (
            <RadioButton
              key={option.id}
              id={`${variant.id}-${option.id}`}
              label={option.name}
              description={option.description || ''}
              selected={isSelected}
              value={option.id}
              onChange={onChange}
            />
          )
        })}
      </Box>
    </Box>
  )
}
